import { render, staticRenderFns } from "./ButtonFloating.vue?vue&type=template&id=afb30bf6"
import script from "./ButtonFloating.vue?vue&type=script&lang=js"
export * from "./ButtonFloating.vue?vue&type=script&lang=js"
import style0 from "./ButtonFloating.vue?vue&type=style&index=0&id=afb30bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports